// extracted by mini-css-extract-plugin
export default {"cookieBarWrap":"style_cookieBarWrap__zE22m","cookieBar":"style_cookieBar__Qa-RJ"};